import { DownloadOutlined } from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { Button, Dropdown } from 'antd'

import { AppAdmin } from 'api/app-admin'
import { EXPORT_TYPE } from 'constants/export-file'
import { downloadBlob, generateFilename } from 'utils/download-file'
import { logError } from 'utils/logger'

interface ExportCSVProps {
  className?: string
}

const ExportCSV = ({ className }: ExportCSVProps) => {
  const handleExport = async (fetchFn: () => Promise<any>, type: string) => {
    try {
      const response = await fetchFn()
      downloadBlob(response.data, generateFilename(type), 'text/csv')
    } catch (error: any) {
      logError(error)
    }
  }

  const menuItems: MenuProps['items'] = [
    {
      key: EXPORT_TYPE.VESTING_HMC.KEY,
      label: EXPORT_TYPE.VESTING_HMC.LABEL,
      onClick: () =>
        handleExport(
          () => AppAdmin.exportByType(EXPORT_TYPE.VESTING_HMC.KEY),
          EXPORT_TYPE.VESTING_HMC.KEY
        ),
    },
    {
      key: EXPORT_TYPE.VESTING_VENTURE.KEY,
      label: EXPORT_TYPE.VESTING_VENTURE.LABEL,
      onClick: () =>
        handleExport(
          () => AppAdmin.exportByType(EXPORT_TYPE.VESTING_VENTURE.KEY),
          EXPORT_TYPE.VESTING_VENTURE.KEY
        ),
    },
    {
      key: EXPORT_TYPE.VESTING_HMC_2019.KEY,
      label: EXPORT_TYPE.VESTING_HMC_2019.LABEL,
      onClick: () =>
        handleExport(
          () => AppAdmin.exportByType(EXPORT_TYPE.VESTING_HMC_2019.KEY),
          EXPORT_TYPE.VESTING_HMC_2019.KEY
        ),
    },
    { type: 'divider' },
    {
      key: EXPORT_TYPE.ALL.KEY,
      label: EXPORT_TYPE.ALL.LABEL,
      onClick: () =>
        handleExport(() => AppAdmin.exportByType(EXPORT_TYPE.ALL.KEY), EXPORT_TYPE.ALL.KEY),
    },
  ]

  return (
    <div className={className}>
      <Dropdown menu={{ items: menuItems }} trigger={['click', 'hover']} placement="bottomRight">
        <Button type="primary" icon={<DownloadOutlined />}>
          Export CSV
        </Button>
      </Dropdown>
    </div>
  )
}

export default ExportCSV
